import { estimateTrendIndicatorWidth } from '../components/TrendIndicator/utilities/estimateTrendIndicatorWidth.js';
import { FONT_WEIGHT } from '../components/TrendIndicator/constants.js';
import { FONT_SIZE } from '@shopify/polaris-viz-core';

// eslint-disable-next-line @shopify/strict-component-boundaries
function getTrendIndicatorData(trendMetadata) {
  if (trendMetadata != null) {
    var _trendMetadata$value;
    const {
      totalWidth
    } = estimateTrendIndicatorWidth((_trendMetadata$value = trendMetadata.value) !== null && _trendMetadata$value !== void 0 ? _trendMetadata$value : '', FONT_SIZE, FONT_WEIGHT);
    return {
      trendIndicatorProps: trendMetadata,
      trendIndicatorWidth: totalWidth
    };
  }
  return {
    trendIndicatorProps: undefined,
    trendIndicatorWidth: 0
  };
}

export { getTrendIndicatorData };
